<div class="row my-3">
  <div class="col-sm-6 col-header">
    Name
  </div>
  <div class="col-sm-6 text-right">
    <span class="add-new-folder" (click)="newFolder()">
      <i class="fa fa-folder-o"></i> {{ 'ADD_NEW_FOLDER' | translate }}
    </span>
  </div>
</div>

<div class="row" *ngIf="mediaLoading">
  <div class="col-md-12">
    <div class="spinner-bar"></div>
  </div>
</div>

<div *ngIf="!mediaLoading">

  <div class="row" *ngIf="creatingFolder">
    <div class="col-sm-12">
      <app-create-media-folder (saveFolderEvent)="saveFolder($event)" (cancelCreateFolderEvent)="cancelCreateFolder($event)"></app-create-media-folder>
    </div>
  </div>

  <div class="row"
       dnd-droppable
       (onDropSuccess)="moveItem($event, folder)"
       [dropZones]="['folder']"
       *ngFor="let folder of folders; let i = index"
       [ngClass]="{'uncategorized-folder': isFolderForUncategorizedItems(folder), 'dropzone-hidden': uncategorizedFolderDropzoneHidden}">
    <div class="col-sm-12">
      <div class="row" *ngIf="!isFolderForUncategorizedItems(folder)">
        <div class="col-md-12">
          <app-media-folder [userId]="userId" (deleteFolderEvent)="deleteFolder($event)" [folder]="folder"></app-media-folder>
        </div>
      </div>
      <div class="row folder-items mb-3" *ngIf="folder.items.length  || !uncategorizedFolderDropzoneHidden">
        <div class="col-sm-12 mt-3" [dragEnabled]="!item.editing" dnd-draggable (onDragStart)="showDropzoneForUncategorizedFolder()" (onDragEnd)="hideDropzoneForUncategorizedFolder()" [dropZones]="['folder', 'root']" [dragData]="{'folder' : folder, 'item' : item}" *ngFor="let item of folder.items; let x = index">
          <app-media-item [userId]="userId" (selectMediaEvent)="onSelectMedia($event)" (deleteMediaEvent)="delete($event)" [item]="item"></app-media-item>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/media-library/browse-media/browse-media.component.html